export default "__VITE_ASSET__CWa6tIIx__"